<div class="flex justify-between items-center">
	<h2>Uploaded documents</h2>
	<app-button size="small" (onClick)="upload()">Upload</app-button>
</div>
<div class="w-2/6 my-3">
	<app-input
		placeholder="Search"
		type="text"
		(debounce)="applySearch($event)"
	></app-input>
</div>
<table
	mat-table
	[dataSource]="dataSource_()"
	[trackBy]="trackByUid"
	matSort
	class="animate w-full dashboard-table mt-5"
>
	<ng-container matColumnDef="name">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
		<td mat-cell *matCellDef="let element">
			<div class="flex gap-2 items-center">
				<button
					class="cursor-pointer hover:underline"
					(click)="openFile(element)"
				>
					{{ element.name }}
				</button>
			</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="type">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
		<td mat-cell *matCellDef="let element">
			{{ element.friendlyType }}
		</td>
	</ng-container>

	<ng-container matColumnDef="uploadedAt">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Uploaded</th>
		<td mat-cell *matCellDef="let element">
			{{ element.uploadedAt | date: 'd MMMM yyyy, h:mm:ss a' }}
		</td>
	</ng-container>

	<ng-container matColumnDef="delete">
		<th mat-header-cell *matHeaderCellDef></th>
		<td mat-cell *matCellDef="let element">
			<div class="flex gap-1">
				<app-button
					btn="tertiary"
					[icon]="ICON.EDIT"
					tooltip="Edit document name"
					[disabled]="!element.allowRename"
					(onClick)="edit(element)"
					*ngIf="!element.virtualized"
				></app-button>
				<app-button
					btn="tertiary"
					[icon]="ICON.DOWNLOAD"
					tooltip="Download document"
					(onClick)="download(element)"
				></app-button>
				<app-button
					btn="tertiary"
					[holdable]="true"
					[icon]="ICON.DELETE"
					class="text-red"
					[disabled]="!element.allowDelete"
					(onClick)="remove(element.id)"
					*ngIf="!element.virtualized"
				></app-button>
			</div>
		</td>
	</ng-container>

	<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
	<tr
		mat-row
		*matRowDef="let row; columns: displayedColumns"
		class="animate"
	></tr>
</table>
